const isIframeVideo = (url: string | undefined) => {
    if (typeof url === "undefined" || url === "") {
        return false;
    }
    const htmlVideo = /\.(mp4|webm|ogg)$/;
    return !htmlVideo.test(url);
};

export default isIframeVideo;
